import { defineNuxtPlugin, useRuntimeConfig } from "#imports";
import { isSupported } from "../utils/isSupported.js";
const ACTIVATION_COOKIE = "ds-visual-coverage";
function markComponentElements(instance, attribute, name) {
  if (instance.$el && typeof instance.$el === "object" && "nodeType" in instance.$el && instance.$el.nodeType === Node.ELEMENT_NODE) {
    ;
    instance.$el.setAttribute(attribute, name);
    return;
  }
  const children = instance.$?.subTree?.children;
  if (Array.isArray(children)) {
    for (const child of children) {
      if (child && typeof child === "object" && "el" in child && child.el && typeof child.el === "object" && "nodeType" in child.el && child.el.nodeType === Node.ELEMENT_NODE) {
        ;
        child.el.setAttribute(attribute, name);
      }
    }
  }
}
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig().public.dsVisualCoverage;
  if (!config.enabled) return;
  const isActivated = () => {
    if (import.meta.dev) return true;
    if (typeof document === "undefined") return false;
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${ACTIVATION_COOKIE}=([^;]*)`)
    );
    return match?.[1] === "1";
  };
  if (!isActivated()) return;
  if (!isSupported()) {
    console.warn(
      "[DS Visual Coverage] Browser not supported (requires requestIdleCallback + Web Workers)"
    );
    return;
  }
  nuxtApp.vueApp.mixin({
    mounted() {
      const name = this.$options.name || this.$options.__name;
      if (name?.startsWith("Rev")) {
        markComponentElements(this, config.attribute, name);
      }
    },
    updated() {
      const name = this.$options.name || this.$options.__name;
      if (name?.startsWith("Rev")) {
        markComponentElements(this, config.attribute, name);
      }
    }
  });
  const route = () => window.location.pathname;
  window.dsVisualCoverage = {
    collect: async () => {
      const { collectCoverageData } = await import("../utils/collectCoverageData.js");
      const { createGetComponentData } = await import("../utils/getComponentData.js");
      const getComponentData = createGetComponentData({
        attribute: config.attribute,
        weights: config.weights
      });
      return collectCoverageData({
        getComponentData,
        log: config.log,
        route: route()
      });
    },
    visualize: async () => {
      const { createCalculateDsVisualCoverages, visualizeCoverage } = await import("@preply/ds-visual-coverage-web");
      const { createGetComponentData } = await import("../utils/getComponentData.js");
      const getComponentData = createGetComponentData({
        attribute: config.attribute,
        weights: config.weights
      });
      const calc = createCalculateDsVisualCoverages({
        getComponentData,
        log: config.log
      });
      calc.run({
        onComplete: (result) => {
          visualizeCoverage({
            result,
            svgRendererAttributeName: "dsVisualCoverage"
          });
        },
        // eslint-disable-next-line no-console
        onError: console.error
      });
    }
  };
  console.info(
    "[DS Visual Coverage] Activated. Use window.dsVisualCoverage.collect() to measure."
  );
});
